/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

interface DownloadLinkCellProps {
    cell: Cell<IngestionFailure>;
}

export const DownloadLinkCell = ({
    cell,
}: DownloadLinkCellProps): JSX.Element => (
        <a
            className="respond-to-mouse px-1 text-primary-500 underline"
            href={cell.value}
        >
            Download
        </a>
    );
